import { Divider, Box } from '@cast/design-system';

import { sidebarDividerWrapperSx } from './sidebarStyles';

export const SidebarDivider = () => (
  <Box sx={sidebarDividerWrapperSx}>
    <Divider />
  </Box>
);
